<template>
    <div>
        <h5 class="text-h5 q-mt-lg q-mb-md">{{ $t(game_data.game_name)}}</h5>

        <q-collapsible class="shadow-2 q-pa-sm q-ma-xs rounded-border" icon="far fa-check-square" right-icon="far fa-check-square" :label="$t('how_to_create_the_game')">
            <div class="q-ma-sm">
                <p>{{ $t('drag_and_drop_instructions') }}</p>
                <p class="text-bold">{{ $t('example') }}</p>
                <p>{{ $t('drag_and_drop_instructions_example') }}</p>
                <p class="q-mt-lg"><em><strong>{{ `${$t('warning')}:` }}</strong>{{ $t('create_game_before_save') }}</em></p>
            </div>
        </q-collapsible>

        <div class="row">
            <div class="col-12 text-center q-mt-md">
                <q-icon name="fas fa-hard-hat" size="xl" style="font-size: 3em;"/>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'AdminGameDragAndDrop',

    props: ['can_save', 'saved_game_data', 'id_game'],

    data() {
        return {
            game_data: {
              game_name: 'drag_and_drop',
            }
        }
    },

    methods: {
    }
}
</script>

<style>

</style>
